export var GpExpirationStatus;
(function (GpExpirationStatus) {
    GpExpirationStatus["EXPIRED"] = "expired";
    GpExpirationStatus["WARNING"] = "warning";
    GpExpirationStatus["NOTICE"] = "notice";
    GpExpirationStatus["NOT_STARTED"] = "not_started";
})(GpExpirationStatus || (GpExpirationStatus = {}));
